export const moveActivePracticeIndex = (index) => dispatch => {
    dispatch( {
        type: 'MOVE_PRACTICE_QUESTION_INDEX',
        payload: index
    });
};